export default {
    attrs: {
    },
    content: {
    }
}
